import { Tooltip, Typography } from 'antd';
import { Link } from 'react-router-dom';

import { EDIT_SALES_FUNNEL_PATH } from '@app/constants';
import type { NFunnels } from '@app/types';

import type { MenuProps } from 'antd';

import '@pages/SalesFunnels/ViewSalesFunnel/styles/ViewSalesFunnelPageHeader.tablet.scss';

const { Text } = Typography;

export const getHeaderDropdownItems = (
  data: NFunnels.SalesFunnelDto | null,
  setIsDeletingModalOpen: (value: boolean) => void
) => {
  if (!data) {
    return [];
  }

  const { Id } = data;

  const headerDropdownItems: MenuProps['items'] = [
    {
      key: '1',
      label: (
        <Tooltip title="Не работает, пока не создана страница редактирования">
          <Link to={`${EDIT_SALES_FUNNEL_PATH}?id=${Id}`}>
            <Text>Редактировать</Text>
          </Link>
        </Tooltip>
      ),
    },
    {
      key: '2',
      label: (
        <Text
          onClick={() => setIsDeletingModalOpen(true)}
          className="view-sales-page-header-dropdown-delete-text"
        >
          Удалить
        </Text>
      ),
    },
  ];

  return headerDropdownItems;
};
